import { IOrderLogService } from "../domain/Interfaces/IOrderLogService";
import { IGetOrdersParams } from "../domain/dtos/IGetOrdersParams";
import { IGetOrdersResponse } from "../domain/dtos/IGetOrdersResponse";

export const GetOrdersUseCase = (service: IOrderLogService, localId: string, params: IGetOrdersParams): Promise<IGetOrdersResponse> => {
  return service.getOrders(localId, params);
}
